import history from '../../util/history'

const onUpdate = room => {
  history.push(`/setting/${room.id}/info`)
  return true
}

export default onUpdate
